import { OPEN_FORCED_EMT_DIALOG, CLOSE_FORCED_EMT_DIALOG } from './ForcedEMTDialog.actions'

const forcedEMTDialogState = {
  open: false,
  skipped: false,
  quoteId: null
}

/**
 * The Forced "Empresa de menor tamaño" Dialog reducer.
 */

const forcedEMTDialogReducer = (state = forcedEMTDialogState, { payload, type }) => {
  switch (type) {
    case OPEN_FORCED_EMT_DIALOG:
      return { ...state, open: true, ...payload }
    case CLOSE_FORCED_EMT_DIALOG:
      return { ...state, open: false, ...payload }
    default:
      return state
  }
}

export default forcedEMTDialogReducer
